export default __webpack_public_path__ + "static/media/coingecko.a37a6073.png";